import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';

import { useMediaCenterPathContext } from 'hb-react/frontoffice/apps/MediaCenter/contexts/MediaCenterPathContext';
import Breadcrumb from 'hb-react/shared/components/DesignSystem/Breadcrumb';
import BreadcrumbLoader from 'hb-react/shared/components/DesignSystem/Breadcrumb/Loader';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import { useMenuName } from 'hb-react/shared/hooks/useMenuName';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import { buildBreadcrumbs } from './utils';

const BreadcrumbContainer = ({ currentFolder }) => {
  const outboxedFontTheme = useOutboxedFontTheme();
  const { mediaCenterFolderPath, mediaCenterPath } =
    useMediaCenterPathContext();
  const { breadcrumbs, uuid, name } = currentFolder;

  const menuName = useMenuName('media_center', __('Media Center'));
  const fullBreadcrumbs = buildBreadcrumbs({
    breadcrumbs,
    uuid,
    name,
    search: window.location.search,
    mediaCenterPath,
    mediaCenterFolderPath,
    menuName,
  });

  if (!fullBreadcrumbs) {
    return null;
  }

  return (
    <ThemeProvider
      theme={outboxedFontTheme.themeName}
      fontBrightness={outboxedFontTheme.fontBrightness}
    >
      <Wrapper dataTestId="breadcrumb-media-center">
        <Breadcrumb breadcrumbs={fullBreadcrumbs} />
      </Wrapper>
    </ThemeProvider>
  );
};

const MediaCenterBreadcrumb = ({ currentFolder, isLoading }) => {
  if (isLoading) {
    return (
      <Wrapper>
        <BreadcrumbLoader />
      </Wrapper>
    );
  }

  if (!currentFolder) {
    return null;
  }

  return <BreadcrumbContainer currentFolder={currentFolder} />;
};

const Wrapper = ({ children, dataTestId }) => (
  <Container display="block" height="auto">
    <Box display="block" mt={6} data-testid={dataTestId}>
      {children}
    </Box>
  </Container>
);

export default MediaCenterBreadcrumb;
